export namespace ProductNs {

    export enum ProductType {
        FREE = 'FR',
        PROFESSIONAL = 'PR',
        BUSINESS = 'BU'
    }

    export interface Product {
        name: string,
        key: ProductNs.ProductType,
        type: 'MONTHLY' | 'YEARLY',
        price: number,
        productId: string,
        quantity:number
    }

    export interface CancelSubscriptionRequest {
        workspaceId:string,
        cancellationReasonId: number,
        reasonText: string,
        productId: string,
    }

    export interface UpdateProductRequest {
        workspaceId:string,
        productId: string,
        quantity: number
    }

}
